import styled from 'styled-components';

export const ACTIVE_JOURNEYS_EMPTY_HEIGHT = '178px';

export const ActiveJourneysPanel = styled.div`
	border-radius: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.dark[8]};

	.empty {
		display: flex;
		align-items: center;
		justify-content: center;
		height: ${ACTIVE_JOURNEYS_EMPTY_HEIGHT};
		padding: 0.25rem;
		text-align: center;
	}

	> .title {
		border-bottom: 1px solid ${({ theme }) => theme.v3.colors.dark[3]};
		padding: 1rem;
	}

	> .journeys {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
		padding: 0.5rem;
	}
`;

export const ActiveJourneyStyles = styled.div`
	border-radius: 0.25rem;

	> .header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 0.5rem;
		padding: 0.5rem;
		border-radius: 0.25rem;
		text-decoration: none;

		&:hover {
			background: ${({ theme }) => theme.v3.colors.dark[6]};
		}

		.header-link {
			display: flex;
			flex: 1 1 auto;
			align-items: center;
			gap: 0.75rem;
			min-width: 0;
			text-decoration: none;
		}

		.icon-badge {
			display: flex;
			padding: 0.5rem;
			border-radius: 0.25rem;
			color: ${({ theme }) => theme.v3.colors.gray[6]};
			background: ${({ theme }) => theme.v3.colors.dark[3]};
		}

		.labels {
			display: flex;
			flex-direction: column;
			min-width: 0;
		}

		.toggle {
			color: ${({ theme }) => theme.v3.colors.gray[8]};
		}
	}

	&.expanded > .header {
		background: ${({ theme }) => theme.v3.colors.dark[6]};
		border-radius: 0.25rem 0.25rem 0 0;
	}

	.indicator {
		padding: 0.5rem;
		border-top: 1px solid ${({ theme }) => theme.v3.colors.dark[3]};
		background: ${({ theme }) => theme.v3.colors.dark[6]};
		color: ${({ theme }) => theme.v3.colors.gray[8]};

		&:last-child {
			border-radius: 0 0 0.25rem 0.25rem;
		}

		&-spacer {
			width: 2rem;
			height: 2rem;
		}
	}

	.counts {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 0.5rem;
	}

	.count {
		display: flex;
		align-items: center;
		gap: 0.25rem;
	}
`;
